import { render } from "./BulkProcessSelection.vue?vue&type=template&id=caa0cf2a"
import script from "./BulkProcessSelection.vue?vue&type=script&lang=js"
export * from "./BulkProcessSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__